/**
 * RootRedirect — resolves "/" once the session has hydrated.
 *
 * MSP posture: an msp_admin (or anyone managing more than one customer) lands on
 * the CUSTOMERS list — the top of the multi-tenant funnel. A single-customer user
 * skips it and goes straight to their org's health landing. No session -> /login.
 */
import { Navigate } from "react-router-dom";
import { useSession } from "@/stores/session";

export function RootRedirect() {
  const me = useSession((s) => s.me);
  const currentOrgId = useSession((s) => s.currentOrgId);

  // RequireAuth guards this subtree, but be defensive if me hasn't hydrated.
  if (!me) return <Navigate to={currentOrgId ? `/o/${currentOrgId}` : "/login"} replace />;

  const managesMany = me.is_msp_admin || me.orgs.length > 1;
  if (managesMany) return <Navigate to="/customers" replace />;

  const firstOrg = me.orgs[0]?.id ?? currentOrgId;
  return <Navigate to={firstOrg ? `/o/${firstOrg}` : "/login"} replace />;
}
